module.exports = __webpack_public_path__ + "static/media/Sap-Logo.d8ac1422.png";